import clsx from 'clsx';
import './Resizer.css';

export type ResizerProps = {
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  onDoubleClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  onMouseDown: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  onTouchStart: (event: React.TouchEvent<HTMLSpanElement>) => void;
  onTouchEnd: (event: React.TouchEvent<HTMLSpanElement>) => void;
  split?: 'vertical' | 'horizontal';
  style?: React.CSSProperties;
  resizerClassName?: string;
  resizerLineClassName?: string;
  active: boolean;
};

export const RESIZER_DEFAULT_CLASSNAME = 'Resizer';

export function Resizer(props: ResizerProps) {
  const {
    active,
    className,
    onClick,
    onDoubleClick,
    onMouseDown,
    onTouchEnd,
    onTouchStart,
    resizerClassName = RESIZER_DEFAULT_CLASSNAME,
    resizerLineClassName,
    split,
    style,
  } = props;

  return (
    <span
      role="presentation"
      className={clsx(resizerClassName, split, className)}
      style={style}
      data-active={active}
      onMouseDown={(event) => onMouseDown(event)}
      onTouchStart={(event) => {
        event.preventDefault();
        onTouchStart(event);
      }}
      onTouchEnd={(event) => {
        event.preventDefault();
        onTouchEnd(event);
      }}
      onClick={(event) => {
        if (onClick) {
          event.preventDefault();
          onClick(event);
        }
      }}
      onDoubleClick={(event) => {
        if (onDoubleClick) {
          event.preventDefault();
          onDoubleClick(event);
        }
      }}
    >
      <span data-active={active} className={clsx('Resizer-line', resizerLineClassName)} />
    </span>
  );
}
